<template>
  <span class="text-highlight-line" />
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .text-highlight-line {
    position: absolute;
    z-index: 1;
    opacity: .85;
    width: 100%;
    left: 0;
    pointer-events: none;
    background-color: #fff;

    .chapter:nth-of-type(odd) & {
      background-color: #000;
    }
    .copy-list-item__title &:first-of-type {
      opacity: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TextHighlightAnimation/TextHighlightLine.vue